// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2bs5r","row":"ProcedureTreatmentSummary_row__SeBHm"};